export const LOCATION = "Tooltip text will be displayed here";

export const CHANGE_DATE = "Tooltip text will be displayed here";
